import React, {useEffect} from 'react';

import AemComponent from '@/components/Aem/AemComponent/AemComponent';
import EditableText from '@/components/Aem/EditableText/EditableText';
import {AppButton} from '@/components/Button';
import * as advanceDiagnosticIconTypes from '@/consts/advanceDiagnostic/advanceDiagnosticIconTypes';
import {ADVANCED_DIAGNOSTICS_FINISH_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import SupportAndStoreTemplate from '@/containers/AdvancedDiagnosticPage/components/SupportAndStoreTemplate';
import {getAriaLabel} from '@/services/accessibilityService';
import amplitudeADTracking from '@/services/analytics/amplitude/amplitudeADTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import appRouterService from '@/services/route/appRouterService';

import AdvancedDiagnosticDescription from '../components/AdvancedDiagnosticDescription';
import AdvancedDiagnosticIcon from '../components/AdvancedDiagnosticIcon';
import AdvancedDiagnosticLayout from '../components/AdvancedDiagnosticLayout';
import AdvancedDiagnosticTitle from '../components/AdvancedDiagnosticTitle';

const AdvancedDiagnosticFinishScreen = () => {
    useEffect(() => {
        amplitudeADTracking.trackADInitialQuestionnaireScreen();
        googleAnalyticsService.trackAdFinishScreenView();
    }, []);

    return (
        <AdvancedDiagnosticLayout>
            <AdvancedDiagnosticLayout.ContentWrapper>
                <AdvancedDiagnosticLayout.Container sectionClassName='h-full justify-between'>
                    <div className='mx-8 flex h-full flex-col items-center justify-center md:mx-0 ml:max-w-none'>
                        <AdvancedDiagnosticIcon
                            className='h-12 w-12 shrink-0'
                            type={advanceDiagnosticIconTypes.SUCCESS}
                        />
                        <AdvancedDiagnosticTitle itemName='finishtitle' />
                        <AdvancedDiagnosticDescription itemName='finishdesc' />
                    </div>

                    <div className='w-full'>
                        <SupportAndStoreTemplate className='mt-10' />

                        <AppButton
                            primary
                            onClick={appRouterService.forwardToDevicesPage}
                            className='mt-4 w-full text-center'
                            aria-label={getAriaLabel(ADVANCED_DIAGNOSTICS_FINISH_BUTTON_ARIA_LABEL)}
                        >
                            <AemComponent
                                component={EditableText}
                                pageName={routePaths.ADVANCE_DIAGNOSTIC}
                                itemName='finishbutton'
                            />
                        </AppButton>
                    </div>
                </AdvancedDiagnosticLayout.Container>
            </AdvancedDiagnosticLayout.ContentWrapper>
        </AdvancedDiagnosticLayout>
    );
};

export default AdvancedDiagnosticFinishScreen;
